jQuery(function ($) {
  $('.hero_2026').each(function () {
    var viewport = this;
    var track = viewport.querySelector('.hero_2026_track');
    if (!track) return;

    var $track = $(track);
    var $slides = $track.children('a');
    var $buttons = $(viewport).find('.hero_2026_arrows button');
    var prevBtn = $buttons.get(0);
    var nextBtn = $buttons.get(1);
    var total = $slides.length;

    if (total <= 1) {
      track.style.transition = 'none';
      track.style.transform = 'translate3d(0,0,0)';
      return;
    }

    $(viewport).on('dragstart.hero2026', 'img,a', function (e) {
      e.preventDefault();
    });

    var index = 0;
    var startX = 0;
    var currentX = 0;
    var pointerDown = false;
    var width = 0;
    var swiping = false;
    var autoDelay = 5000;
    var autoTimer = null;

    function measure() {
      width = viewport.getBoundingClientRect().width;
    }

    function clamp(i) {
      return Math.max(0, Math.min(i, total - 1));
    }

    function wrap(i) {
      if (i < 0) return total - 1;
      if (i >= total) return 0;
      return i;
    }

    function goTo(i, animate) {
      index = clamp(i);
      track.style.transition = animate ? 'transform 250ms ease' : 'none';
      track.style.transform = 'translate3d(' + (-index * width) + 'px,0,0)';
    }

    function goToWrapped(i, animate) {
      index = wrap(i);
      track.style.transition = animate ? 'transform 250ms ease' : 'none';
      track.style.transform = 'translate3d(' + (-index * width) + 'px,0,0)';
    }

    function stopAuto() {
      if (autoTimer) {
        clearInterval(autoTimer);
        autoTimer = null;
      }
    }

    function startAuto() {
      stopAuto();
      autoTimer = setInterval(function () {
        goToWrapped(index + 1, true);
      }, autoDelay);
    }

    function resetAuto() {
      stopAuto();
      startAuto();
    }

    function onPointerDown(e) {
      if (e.pointerType === 'mouse' && e.button !== 0) return;

      measure();
      pointerDown = true;
      swiping = false;
      startX = e.clientX;
      currentX = startX;

      stopAuto();
    }

    function onPointerMove(e) {
      if (!pointerDown) return;

      currentX = e.clientX;
      var dx = currentX - startX;

      if (!swiping && Math.abs(dx) > 8) {
        swiping = true;
        track.style.transition = 'none';

        try {
          track.setPointerCapture(e.pointerId);
        } catch (err) {}
      }

      if (!swiping) return;

      var offset = (-index * width) + dx;

      if ((index === 0 && dx > 0) || (index === total - 1 && dx < 0)) {
        offset = (-index * width) + (dx * 0.35);
      }

      track.style.transform = 'translate3d(' + offset + 'px,0,0)';
    }

    function onPointerUp(e) {
      if (!pointerDown) return;
      pointerDown = false;

      if (!swiping) {
        resetAuto();
        return;
      }

      var dx = currentX - startX;
      var threshold = Math.min(80, width * 0.2);

      if (dx > threshold) {
        goToWrapped(index - 1, true);
      } else if (dx < -threshold) {
        goToWrapped(index + 1, true);
      } else {
        goTo(index, true);
      }

      try {
        track.releasePointerCapture(e.pointerId);
      } catch (err) {}

      resetAuto();
    }

    if (window.PointerEvent) {
      track.addEventListener('pointerdown', onPointerDown, { passive: true });
      track.addEventListener('pointermove', onPointerMove, { passive: true });
      track.addEventListener('pointerup', onPointerUp, { passive: true });
      track.addEventListener('pointercancel', onPointerUp, { passive: true });
    }

    $track.on('click.hero2026', 'a', function (e) {
      if (swiping) {
        e.preventDefault();
        e.stopImmediatePropagation();
        swiping = false;
      }
    });

    if (prevBtn) {
      prevBtn.addEventListener('click', function (e) {
        e.preventDefault();
        goToWrapped(index - 1, true);
        resetAuto();
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', function (e) {
        e.preventDefault();
        goToWrapped(index + 1, true);
        resetAuto();
      });
    }

    $(viewport).on('mouseenter.hero2026', function () {
      stopAuto();
    });

    $(viewport).on('mouseleave.hero2026', function () {
      startAuto();
    });

    measure();
    goTo(0, false);
    startAuto();

    $(window).on('resize.hero2026', function () {
      measure();
      goTo(index, false);
    });
  });
});